// @vendors
const { formatText, FormattedText, hasTranslation } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const React = require('react');

// @ components
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');

// @utilities
const { recordLink } = require("utilities/tagging");

// @constants
const { CHECKED_ACTION_EVENT, CONSENTS_ACTION_EVENT, UNCHECKED_ACTION_EVENT } = require("constants/tagging");
import { E_ACCOUNT_LOAN_PRODUCT_ALIAS } from 'constants/hiringProductInformation'

import { DEPOSIT_PRECONTRACTUAL_TYPE, DEPOSITS_CONTRACT_INDEXES } from 'components/deposits/constants/depositsConstants';

require('./ContractsConfirmationCheckboxGroup.scss');

class ContractsConfirmationCheckboxGroup extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const {
            confirmationCheckboxes,
            setTermsAndCondsText,
        } = this.props;

        if (!!setTermsAndCondsText) {
            const checkboxlabelsRaw = confirmationCheckboxes.getIn(['list', 0, 'labels']);

            if (!!checkboxlabelsRaw) {
                let checkboxlabels;
                
                checkboxlabelsRaw.forEach(item => {
                    if (!!checkboxlabels) {
                        checkboxlabels = `${checkboxlabels} ${formatText(item.get('text'))}`;
                    } else {
                        checkboxlabels = formatText(item.get('text'));
                    }
                });

                setTermsAndCondsText(checkboxlabels);
            }
        }
    }

    getDocumentUrl() {
        const { getDocumentsOkApiById, documentId }  = this.props;

        getDocumentsOkApiById(documentId, undefined, true);
    }

    getDocumentPayload = (contractWizard, { originCountry, productId }) => {
        const contractIndex = contractWizard.get('name_contract')
        const isDeposit = DEPOSITS_CONTRACT_INDEXES.includes(contractIndex)
        if (isDeposit) {
            return {
                metadata: {
                  depositIdentify: contractWizard.getIn(['deposit_product', 'depositIdentify']),
                  language: originCountry,
                  termPeriod: formatText('contractsView-months'),
                  productType: formatText(`${contractWizard.getIn(['deposit_product', 'context'])}-${contractWizard.getIn(['deposit_product', 'name'])}`)
                },
                precontractualType: DEPOSIT_PRECONTRACTUAL_TYPE[contractIndex]
              }
        }
        return {
            metadata: {
                productId: productId,
                language: originCountry
            },
            precontractualType: E_ACCOUNT_LOAN_PRODUCT_ALIAS
        }
    }

    getDocumentUrlOrById() {
        const {
            getPrecontractualDocumentURLOrID,
            getDocumentsOkApiById,
            match: { params: { redirect: productId } },
            originCountry,
            contractWizard,
        } = this.props

        const payload = this.getDocumentPayload(contractWizard, { originCountry, productId })

        getPrecontractualDocumentURLOrID({
            payload,
            onDocumentURLCallback: (url)=>{
                window.open(url, '_blank')
            },
            onDocumentIDCallback: (id)=>{
                getDocumentsOkApiById(id, undefined, true)
            }
        })
    }

    buildLabels(labels) {
        const { precontractualLink } = this.props;
        const labelElements = labels.map(item => {
            let element = item.get('id') === 'btn_contractsView_transfer-deposit'
                ? <FormattedText key={item.get('text')} value={item.get('text')} injectedStrings={[item.get('href')]} />
                : <FormattedText key={item.get('text')} value={item.get('text')} />;
            let url;

            if (item.get('id') === 'btn_ContractsView_service-contract') {
                url = precontractualLink;
            } else if (['btn_contractsView_transfer-deposit', 'btn_contractsView_deposit-dynamic-contractual-doc', 'btn_contractsView_saving-document-dynamic'].includes(item.get('id'))){
                url = null;
            }
            else {
                const href = item.get('href');

                url = hasTranslation(href) ? formatText(href) : href;
            }

            if (url) {
                element = (
                    <OKLink
                        key={item.get('text')}
                        id={item.get('id')}
                        target="_blank"
                        to={url}
                        modifier="emphasize"
                    >
                        {element}
                    </OKLink>
                );
            }

            if (['btn_contractsView_deposit-dynamic-contractual-doc', 'btn_contractsView_saving-document-dynamic'].includes(item.get('id'))) {
                element = (
                    <OKLink
                        key={item.get('text')}
                        id={item.get('id')}
                        modifier="emphasize"
                        onClick={() => this.getDocumentUrlOrById()}
                    >
                        {element}
                    </OKLink>
                )
            }

            return element;
        });

        return (<p>{labelElements}</p>);
    }

    handleChange(event){
        const changedId = event.target.id;
        const { confirmationCheckboxes, customCategoryEvent, updateConfirmationCheckboxes } = this.props;
        const checkboxList = confirmationCheckboxes.get('list');
        const clickedCheckboxValue = checkboxList.find(x => x.get('idName') === changedId).get('value');

        let areValid = true;
        const updatedCheckboxList = checkboxList.map(item => {
            let tempItem = item;

            // We update the value of the clicked item and set errorState to false so we hide the error message if it was showing
            if (tempItem.get('idName') === changedId){
                tempItem = tempItem.withMutations(map => {
                    map.set('value', !clickedCheckboxValue).set('errorState', false)
                })
            }

            // if any of the required checkboxes is not checked, the areValid flag is set to false
            // we don't update here the errorState to true because that would show the error message instantly
            if (areValid && tempItem.get('isRequired') && !tempItem.get('value')){
                areValid = false;
            }

            return tempItem;
        });

        updateConfirmationCheckboxes({
            areValid,
            list: updatedCheckboxList
        });

        recordLink(customCategoryEvent ? customCategoryEvent : window.utag_last_name, CONSENTS_ACTION_EVENT, event.target.checked ? CHECKED_ACTION_EVENT : UNCHECKED_ACTION_EVENT );
    }

    render() {
        const { confirmationCheckboxes, areDisabled } = this.props;
        const checkboxList = confirmationCheckboxes.get('list');

        const checkboxGroup = checkboxList.map(checkboxItem => {
            const labels = this.buildLabels(checkboxItem.get('labels'));
            const errorMessage = formatText(checkboxItem.get('errorMessage'));

            return (
                <OKCheckbox
                    key={checkboxItem.get('idName')}
                    idName={checkboxItem.get('idName')}
                    value={checkboxItem.get('value')}
                    onChange={this.handleChange}
                    label={labels}
                    errorState={checkboxItem.get('errorState')}
                    errorMessage={errorMessage}
                    disabled={areDisabled}
                />
                );
        }, this);

        return (<div>{checkboxGroup}</div>);
    }
}

ContractsConfirmationCheckboxGroup.defaultProps = {
    confirmationCheckboxes: {
        areValid: false,
        list: []
    },
    customCategoryEvent: undefined,
    areDisabled: false,
    documentId: null,
    getDocumentsOkApiById: () => {},
    getPrecontractualDocumentURLOrID: () => {}
};

ContractsConfirmationCheckboxGroup.propTypes = {
    confirmationCheckboxes: PropTypes.object.isRequired,
    customCategoryEvent: PropTypes.string,
    documentId: PropTypes.string,
    getDocumentsOkApiById: PropTypes.func,
    getPrecontractualDocumentURLOrID: PropTypes.func.isRequired,
    updateConfirmationCheckboxes: PropTypes.func.isRequired,
    precontractualLink: PropTypes.string,
    areDisabled: PropTypes.bool,
    setTermsAndCondsText: PropTypes.func,
};

module.exports = ContractsConfirmationCheckboxGroup;